import "./evcal-sass/evcal.scss";

import "idempotent-babel-polyfill";

require("./js/evcal.js");
